import { readonly, ref } from 'vue';

/**
 * Which list is on screen, for the things that live outside it.
 *
 * The search bar sits in the navbar and the advanced query builder opens from
 * there, yet both have to speak about the list underneath: its search
 * declaration (which filters exist), its API resource and the parameters it
 * always sends (a section, a parent record). Rather than have each of them
 * guess from the route — the mapping is one-way and already frayed — the list
 * itself says what it is while it is mounted.
 *
 * Empty when no list is on screen, which is the honest answer for a dashboard.
 */
const activeList = ref(null);

export function useActiveList() {
    /**
     * @param {{ resource: string, objectType: ?string, staticParams: Object }} list
     */
    function setActiveList(list) {
        activeList.value = list;
    }

    function clearActiveList(resource) {
        // A list unmounting after its successor mounted (route change) must not
        // erase the new one.
        if (!resource || activeList.value?.resource === resource) {
            activeList.value = null;
        }
    }

    return { activeList: readonly(activeList), setActiveList, clearActiveList };
}
